import { Mutation } from '../types';
import Vue from 'vue';

export default {
  [Mutation.SET_SCHEDULES](state, { result, hash }) {
    let schedules = [];
    let keyCounter = 1;
    result.forEach(function(schedule) {
      let scheduleData = {
        key: keyCounter,
        id: schedule.id,
        days: {
          mon: schedule.mon,
          tue: schedule.tue,
          wed: schedule.wed,
          thu: schedule.thu,
          fri: schedule.fri,
          sat: schedule.sat,
          sun: schedule.sun,
        },
        timeOn: schedule.start,
        timeOff: schedule.end,
        intervalOn: schedule.interval_on,
        intervalOff: schedule.interval_off,
      };

      schedules.push(scheduleData);
      keyCounter += 1;
    });

    let record = {
      hash: hash,
      schedules: schedules,
    };

    let index = state.schedules.findIndex((h) => h.hash === hash);
    if (index === -1) {
      state.schedules.push(record);
    } else {
      Vue.set(state.schedules, index, record);
    }
  },
};
